import * as config from "../app.config";
import { USER_MESSAGE, setHeaders } from "./User";
import axios from "axios";
import moment from "moment";

export const FETCH_VENDORS = "FETCH_VENDORS";
export const FETCH_VENDOR = "FETCH_VENDOR";
export const ADD_VENDOR = "ADD_VENDOR";
export const UPDATE_VENDOR = "UPDATE_VENDOR";
export const DELETE_VENDOR = "DELETE_VENDOR";
export const SET_VENDOR_DELETE_CONFIRM = "SET_VENDOR_DELETE_CONFIRM";

function _handleErrors(err) {
  return dispatch => {
    const status = (err && err.response && err.response.status) || 401;
    switch (status) {
      case 401:
        dispatch({
          type: USER_MESSAGE,
          msgType: "error",
          text: "Invalid or expired session, please login again",
          key: moment().unix()
        });
        //dispatch(handleLogout());
        break;
      case 409:
        dispatch({
          type: USER_MESSAGE,
          msgType: "error",
          text: "Item already exists",
          key: moment().unix()
        });
        break;
      case 403:
        //dispatch(handleLogout());
        break;
      default:
    }
  };
}

export function fetchVendorList() {
  return (dispatch, getState) => {
    axios
      .get(`${config.ENDPOINTS["main"]}/vendor/list`, {
        headers: setHeaders()
      })
      .then(resp => {
        dispatch({ type: FETCH_VENDORS, payload: resp.data });
      })
      .catch(err => {
        dispatch(_handleErrors(err));
      });
  };
}

export function fetchVendor(vendorId) {
  return (dispatch, getState) => {
    axios
      .get(`${config.ENDPOINTS["main"]}/vendor/${vendorId}`, {
        headers: setHeaders()
      })
      .then(resp => {
        dispatch({ type: FETCH_VENDOR, payload: resp.data });
      })
      .catch(err => {
        dispatch(_handleErrors(err));
      });
  };
}

export function addVendor(values) {
  return (dispatch, getState) => {
    axios
      .post(`${config.ENDPOINTS["main"]}/vendor`, values, {
        headers: setHeaders()
      })
      .then(resp => {
        dispatch({
          type: USER_MESSAGE,
          msgType: "success",
          text: "Vendor added successfully",
          key: moment().unix()
        });
      })
      .catch(err => {
        dispatch(_handleErrors(err));
      });
  };
}

export function updateVendor(vendorId, values) {
  return (dispatch, getState) => {
    axios
      .put(`${config.ENDPOINTS["main"]}/vendor/${vendorId}`, values, {
        headers: setHeaders()
      })
      .then(resp => {
        dispatch({
          type: USER_MESSAGE,
          msgType: "success",
          text: "Vendor updated successfully",
          key: moment().unix()
        });
        dispatch(fetchVendor(vendorId));
      })
      .catch(err => {
        dispatch(_handleErrors(err));
      });
  };
}

export function deleteVendorConfirm(vendorId) {
  return dispatch => {
    dispatch({ type: SET_VENDOR_DELETE_CONFIRM, showModal: true, vendorId });
  };
}

export function clearVendorDelete() {
  return dispatch => {
    dispatch({
      type: SET_VENDOR_DELETE_CONFIRM,
      showModal: false,
      vendorId: null
    });
  };
}

export function deleteVendor(vendorId) {
  return (dispatch, getState) => {
    axios
      .delete(`${config.ENDPOINTS["main"]}/vendor/${vendorId}`, {
        headers: setHeaders()
      })
      .then(resp => {
        dispatch({
          type: USER_MESSAGE,
          msgType: "success",
          text: "Vendor deleted successfully",
          key: moment().unix()
        });
        dispatch(fetchVendorList());
        dispatch(clearVendorDelete());
      })
      .catch(err => {
        dispatch(_handleErrors(err));
      });
  };
}

export function processVendorDetail(values) {
  return dispatch => {
    if (values.id === "") {
      dispatch(addVendor(values));
    } else {
      dispatch(updateVendor(values.id, values));
    }
  };
}

export function clearVendor() {
  return dispatch => {
    dispatch({ type: FETCH_VENDOR, payload: {} });
  };
}
